import { addEvent } from './domutils';
import { IFRAME_MESSAGE_PREFIX } from './const';

export class IFrameMessageListener {
  constructor(iframeId, sender = null, messagePrefix = IFRAME_MESSAGE_PREFIX) {
    this.iframeId = iframeId;
    this.messagePrefix = messagePrefix;
    this.listeners = {};
    this.sender = sender || window;
  }

  startListening() {
    addEvent(this.sender, 'message', (event) => this.onIFrameMessage(event));
  }

  listen(message, listener) {
    this.listeners[message] = listener;
  }

  onIFrameMessage(event) {
    const { data } = event;
    if (data?.event && data.event.startsWith(this.messagePrefix) && data.iframe_id === this.iframeId) {
      const message = data.event.slice(this.messagePrefix.length);
      const listener = this.listeners[message];
      if (listener) listener(data);
    }
  }
}

export class IFrameMessageSender {
  constructor(iframeId, recipient = null, url = '*', messagePrefix = IFRAME_MESSAGE_PREFIX) {
    this.iframeId = iframeId;
    this.messagePrefix = messagePrefix;
    this.recipient = recipient || window.parent;
    this.url = url;
  }

  send(message, data = {}) {
    this.recipient.postMessage(
      {
        event: `${this.messagePrefix}${message}`,
        iframe_id: this.iframeId,
        ...data,
      },
      this.url,
    );
  }
}
